<template>
  <div class="animated fadeIn">
    <Spinner v-if="loading"></Spinner>
    <div class="row" v-if="super_user == 1">
      <div class="col-sm-8">
        <div class="card">
          <div class="card-header">
            <span class="title_head">Company Details<p v-show="hide">{{ super_user }}</p></span></div>
              <div class="card-body">
                <div class="alert alert-success" role="alert"  v-if="messagesucc != ''" data-dismiss="alert" >
                  <strong>{{messagesucc}} </strong>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group" >
                      <label for="name">Company Name<span class="star">*</span></label>
                      <input type="hidden" name="aaa" v-model="reg_view">
                      <input type="text" class="form-control" :class="{'is-invalid':hasErrors.companyname}" id="company_name" name="company_name" placeholder="Enter Company Name" v-model="company.name"  v-on:keyup="onComplete('false','cmpname')"  autocomplete="off">  
                      <small class="help-block" v-if="hasErrors.companyname" ><strong style="color: red;">{{hasErrors.companyname}}</strong></small>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                    <label for="name">Company Type <span class="star">*</span></label>
                    <!--  <v-select  v-model="selectedCategory" label="desc" :options="comptype1"></v-select> 
                    -->
                    <model-list-select :list="comptype1" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="companycode" option-text="desc" v-model="selectedCategory" placeholder="Select Company Type" v-on:input="onComplete('false','cmptype')" autocomplete="off">
                    </model-list-select >
                    <small class="help-block" v-if="hasErrors.cmptype" ><strong style="color: red;">{{hasErrors.cmptype}}</strong></small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="name">Address </label>
                      <input type="text" class="form-control" :class="{'is-invalid':hasErrors.companyadd1}" id="address1" name="address1" placeholder="Enter Address" v-model="company.add"  v-on:keyup="onComplete('false','address')"  autocomplete="off"> 
                      <small class="help-block" v-if="hasErrors.companyadd1" ><strong style="color: red;">{{hasErrors.companyadd1}}</strong></small>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="name">Country <span class="star">*</span></label>
                      <model-list-select :list="conopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="country_name" option-text="country_name" v-model="con" placeholder="Select Country" @input="state1"  v-on:input="onComplete('false','con')"  autocomplete="off"></model-list-select >
                      <small  class="help-block" v-if="hasErrors.conty" ><strong style="color: red;">{{hasErrors.conty}}</strong></small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="name">State <span class="star">*</span></label>
                      <model-list-select :list="stateopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="state_name" option-text="state_name" v-model="stateo1" placeholder="Select State" @input="city1"  v-on:input="onComplete('false','state')"  autocomplete="off"></model-list-select>
                      <small class="help-block" v-if="hasErrors.stateopt1" ><strong style="color: red;">{{hasErrors.stateopt1}}</strong></small>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="name">City <span class="star">*</span></label>
                      <model-list-select :list="cityopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="city_name" option-text="city_name" v-model="city" placeholder="Select City" v-on:input="onComplete('false','city')"  autocomplete="off"></model-list-select>
                      <small class="help-block" v-if="hasErrors.ctyopt" ><strong style="color: red;">{{hasErrors.ctyopt}}</strong></small>
                    </div>
                  </div>
                </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="name">Pincode <span class="star">*</span></label>
                   <input type="text" class="form-control" :class="{'is-invalid':hasErrors.companypin}" id="alt_product_id" name="alt_product_id" placeholder="Enter Pincode" v-model="company.pincode" v-on:keyup="onComplete('false','pncd')"  autocomplete="off">  
                    <small  class="help-block" v-if="hasErrors.companypin" ><strong style="color: red;">{{hasErrors.companypin}}  </strong></small>              
                 </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="name">Company Phone No.<span class="star">*</span></label>
                  <input type="text" class="form-control" :class="{'is-invalid':hasErrors.compphone}" id="cmp_phone" name="cmp_phone" placeholder="Enter Company Phone No" v-model="company.companyphone" v-on:keyup="onComplete('false','companyphone')"  autocomplete="off">
                   <small  class="help-block" v-if="hasErrors.compphone" ><strong style="color: red;">{{hasErrors.compphone}}</strong></small>
                </div>
              </div>
          </div>
          <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="name">Company Email <span class="star">*</span></label>
                  <input type="text" class="form-control" :class="{'is-invalid':hasErrors.companymail}" id="cmp_email" name="cmp_email" placeholder="Enter Company Email" v-model="company.email" v-on:keyup="onComplete('false','email')"  autocomplete="off">
                  <small  class="help-block" v-if="hasErrors.companymail" ><strong style="color: red;">{{hasErrors.companymail}}</strong></small>

                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="name">Company Logo </label>     
                  <input type="file" name="image1" id="image1" accept="image/*" class="form-control filesize" v-on:change="onComplete('false','logo')"  autocomplete="off">
                  <small class="form-text text-muted" v-if="hasErrors.image1!=null" ><strong style="color: red;">{{hasErrors.image1}}</strong></small>
                  <p v-if="view.image1!==null">Click to view uploaded Image/File <a :href="view.image1_href" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                </div>
              </div>
            </div>
             <div class="row">
               <div class="col-md-6">
                <div class="form-group">
                  <label for="name">Company Registration Year </label>
                  <model-list-select :list="yearopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="year" option-text="year" v-model="sel_year" placeholder="Select Year" autocomplete="off"></model-list-select>
                </div>
              </div>
             </div>
            <hr>
              <h6 class="page_head">Company Document Details</h6>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">Corporate Identity Number </label>
                    <div class="input-group">
                    <input type="text" class="form-control" :class="{'is-invalid':hasErrors.companycin}" id="product_alert_qty" aria-label="Enter Corporate Identity Number" aria-describedby="btnGroupAddon" name="product_alert_qty"  v-model="company.cin" placeholder="Enter Company  CIN Number"  v-on:keyup="onComplete('false','cin')"  autocomplete="off">
                    </div>
                    <small class="help-block" v-if="hasErrors.companycin"><strong style="color: red;">{{hasErrors.companycin}}</strong></small>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">CIN Certificate </label>
                     <input type="file" class="form-control filesize" name="image2" id="image2" placeholder="Enter Company CIN Numberr" v-on:change="onComplete('false','cincert')"  autocomplete="off">
                     <small class="form-text text-muted" v-if="hasErrors.image2!=null" ><strong style="color: red;">{{hasErrors.image2}}</strong></small>
                     <p v-if="view.image2!=null">Click to view uploaded Image/File <a :href="view.image2_href" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">GST/VAT Number </label>
                    <div class="input-group">
                    <input type="text" class="form-control" :class="{'is-invalid':hasErrors.companygst}"  placeholder="Enter Company GST/VAT Number" aria-label="Input group example" aria-describedby="btnGroupAddon" v-model="company.gst" v-on:keyup="onComplete('false','gst')"  autocomplete="off">
                    </div>
                    <small class="help-block" v-if="hasErrors.companygst" ><strong style="color: red;">{{hasErrors.companygst}}</strong></small>
                  </div>
                </div>
                 <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">GST Certificate </label>
                    <input type="file" name="image3" id="image3" accept="image/*" class="form-control filesize" v-on:change="onComplete('false','gstcert')"  autocomplete="off">
                    <small class="form-text text-muted" v-if="hasErrors.image3!=null" ><strong style="color: red;">{{hasErrors.image3}}</strong></small>
                    <p v-if="view.image3!=null">Click to view uploaded Image/File <a :href="view.image3_href" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                  </div>
                </div>
              </div>
               

              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">PAN Number <span style="color:red">*</span></label>
                    <div class="input-group">
                    <input type="text" class="form-control" :class="{'is-invalid':hasErrors.companypan}"  placeholder="Enter Company PAN Number" aria-label="Input group example" aria-describedby="btnGroupAddon" v-model="company.pan" v-on:keyup="onComplete('false','pan')"  autocomplete="off">
                    </div>
                    <small class="help-block" v-if="hasErrors.companypan"><strong style="color: red;">{{hasErrors.companypan}}</strong></small>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">PAN Certificate </label>
                    <input type="file" class="form-control filesize" id="image4" name="image4" placeholder="Enter Company Pan Numberr" v-on:change="onComplete('false','pancert')"  autocomplete="off">
                    <small class="form-text text-muted" v-if="hasErrors.image4!=null" ><strong style="color: red;">{{hasErrors.image4}}</strong></small>
                    <p v-if="view.image4!=null">Click to view uploaded Image/File <a :href="view.image4_href" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                  </div>
                </div>
              </div>


              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">TAN Number </label>
                    <div class="input-group">
                    <input type="text" class="form-control" :class="{'is-invalid':hasErrors.companytan}" id="cmp_tan" name="cmp_tan" placeholder="Enter Company Tan Number" aria-label="Input group example" aria-describedby="btnGroupAddon" v-model="company.tan" v-on:keyup="onComplete('false','tan')"  autocomplete="off">
                    </div>
                    <small class="help-block" v-if="hasErrors.companytan" ><strong style="color: red;">{{hasErrors.companytan}}</strong></small>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">TAN Certificate </label>
                    <input type="file" class="form-control filesize" id="image5" name="image5" placeholder="Enter Company Pan Numberr"  v-on:change="onComplete('false','tancert')"  autocomplete="off">
                    <small class="form-text text-muted" v-if="hasErrors.image5!=null" ><strong style="color: red;">{{hasErrors.image5}}</strong></small>
                    <p v-if="view.image5!=null">Click to view uploaded Image/File <a :href="view.image5_href" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                  </div>
                </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="name">Company Profile </label>
                      <vue-editor v-model="company.profile" v-on:input="onComplete('false','profile')"></vue-editor>
                      <small  class="help-block" v-if="hasErrors.companyprofile" ><strong style="color: red;">{{hasErrors.companyprofile}}</strong></small>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="reg_rights === true" class="card-footer">
                <button type="submit" class="btn btn-sm btn-primary" @click.prevent="finalSave()"><i class="fa fa-dot-circle-o"></i> Save</button>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="card">
              <div class="card-header">
                <span class="title_head">Company Bank Details</span>
                <small></small>
              </div>
              <div class="card-body">
                <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="name">Bank Name </label>
                  <input type="text" class="form-control"  :class="{'is-invalid':hasErrors.banknm}" id="bankname" name="bankname" placeholder="Enter your Bank Name"  v-model="company.bankname" v-on:keyup="onComplete('false','bankname')"  autocomplete="off">
                  <small  class="help-block" v-if="hasErrors.banknm" ><strong style="color: red;">{{hasErrors.banknm}}</strong></small>
                </div>
              </div>
               <div class="col-sm-12">
                <div class="form-group">
                  <label for="name">Bank Holder Name </label>
                  <input type="text" class="form-control" id="bankholder" :class="{'is-invalid':hasErrors.bankac}" name="bankholder" placeholder="Enter your Bank Holder Name"  v-model="company.bankholdername" v-on:keyup="onComplete('false','bankhldname')"  autocomplete="off">
                  <small  class="help-block" v-if="hasErrors.bankholdername" ><strong style="color: red;">{{hasErrors.bankholdername}}</strong></small>                
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="name">Account Number </label>
                  <input type="text" class="form-control" id="bankacc" :class="{'is-invalid':hasErrors.bankac}" name="bankacc" placeholder="Enter your Bank Account Number"  v-model="company.bankaccount" v-on:keyup="onComplete('false','bankacc')"  autocomplete="off">
                  <small  class="help-block" v-if="hasErrors.bankac" ><strong style="color: red;">{{hasErrors.bankac}}</strong></small>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="name">IFSC Code </label>
                  <input type="text" class="form-control" id="ifsc" :class="{'is-invalid':hasErrors.bankifsc}" name="ifsc" placeholder="Enter Bank IFSC Code"  v-model="company.ifsc" v-on:keyup="onComplete('false','ifsc')"  autocomplete="off">
                  <small  class="help-block" v-if="hasErrors.bankifsc" ><strong style="color: red;">{{hasErrors.bankifsc}}</strong></small>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="name">Branch </label>
                  <input type="text" class="form-control" :class="{'is-invalid':hasErrors.bankbrnch}" id="bankbranch" name="bankbranch" placeholder="Enter Branch Name"  v-model="company.branch" v-on:keyup="onComplete('false','branch')"  autocomplete="off">
                  <small  class="help-block" v-if="hasErrors.bankbrnch" ><strong style="color: red;">{{hasErrors.bankbrnch}} </strong></small>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="name">MICR Code </label>
                  <input type="text" class="form-control" id="micrcode" :class="{'is-invalid':hasErrors.bankmicr}"  name="micrcode" placeholder="Enter MICR code"  v-model="company.micr" v-on:keyup="onComplete('false','micr')"  autocomplete="off">
                  <small  class="help-block" v-if="hasErrors.bankmicr" ><strong style="color: red;">{{hasErrors.bankmicr}}</strong></small>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="name">Swift Code </label>
                  <input type="text" class="form-control" id="Swiftcode" :class="{'is-invalid':hasErrors.bankswft}"  name="Swiftcode" placeholder="Enter Bank Swift Code"  v-model="company.code" v-on:keyup="onComplete('false','swiftcode')"  autocomplete="off">
                  <small  class="help-block" v-if="hasErrors.bankswft" ><strong style="color: red;">{{hasErrors.bankswft}} </strong></small>
                </div>
              </div>
            </div>
          </div>  
        </div>
      </div>
    </div>
  

    <!-- Only View -->
    <div class="row" v-else-if="shop_user == 2">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <span class="title_head">Company Details<p v-show="hide">{{ reg_view }}</p></span></div>
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group" >
                      <label for="name">Company Name</label><br>
                      <label for="name"><h5>{{company.name}}</h5></label>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="name">Company Type</label><br>
                      <label for="name"><h5 v-if="selectedCategory.desc!=''">{{selectedCategory.desc}}</h5></label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="name">Address</label><br>
                      <label for="name"><h5>{{company.add}}, <span v-if="city.city_name!=''">{{city.city_name}}</span>, <span v-if="stateo1.state_name!=''">{{stateo1.state_name}}</span> <span v-if="company.pincode!=''">- ({{company.pincode}})</span>, {{con.country_name}}</h5></label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="name">Company Phone</label><br>
                      <label for="name"><h5>{{company.companyphone}}</h5></label>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="name">Company Email</label><br>
                      <label for="name"><h5>{{company.email}}</h5></label>
                    </div>
                  </div>
                </div>

              <h6 class="page_head">Company Document Details</h6>

              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">Corporate Identity Number </label><br>
                    <label for="name"><h5>{{company.cin}}</h5></label>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">GST/VAT Number</label><br>
                    <label for="name"><h5>{{company.gst}}</h5></label>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">PAN Number</label><br>
                    <label for="name"><h5>{{company.pan}}</h5></label>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">TAN Number</label><br>
                    <label for="name"><h5>{{company.tan}}</h5></label>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="name">Company Profile </label>
                    <span v-html="company.profile"></span> 
                  </div>
                </div>
              </div>


              <h6 class="page_head">Company Bank Details</h6>

              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">Bank Name</label><br>
                    <label for="name"><h5>{{company.bankname}}</h5></label>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">Bank Holder Name</label><br>
                    <label for="name"><h5>{{company.bankholdername}}</h5></label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">Account Number</label><br>
                    <label for="name"><h5>{{company.bankaccount}}</h5></label>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">IFSC Number</label><br>
                    <label for="name"><h5>{{company.ifsc}}</h5></label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">Branch</label><br>
                    <label for="name"><h5>{{company.branch}}</h5></label>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">MICR Code</label><br>
                    <label for="name"><h5>{{company.micr}}</h5></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Restricted -->
      <div class="row" v-else>
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <span class="title_head">RESTRICTED</span>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <h3>You cannot access this page</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  import Spinner from "../spinner.vue";
  import { VueEditor } from 'vue2-editor';
  // import DatePicker from 'vue2-datepicker';
  export default {
  name:'Registration',
  components: {
    // 'date-picker':  DatePicker,
    Spinner,
    VueEditor
  },
  data(){
    return {
      // reg_year:null,
      pg_view:false,
      pg_rights:false,
      hide: false,
      access_token:null,
      content: '<h1>Company Profile</h1>',
      selectedCategory:null,
      con:null,
      loading:false,
      submit_true:0,
      comptype1:[],
      largeModal: false,
      city:null,
      stateo1:null,
      messagesucc:'',
      messagesucc1:false,
      countryname:'',
      statename:'',
      cmp_type:'',
      cityname:'',
      allowableLogoTypes: ['image/jpg', 'image/jpeg', 'image/png', 'image/bmp'],
      allowableTypes: ['image/jpg', 'image/jpeg', 'image/png', 'image/bmp', 'application/pdf'],
      maximumSize: 500000,
      cityopt:[],
      conopt:[],
      stateopt:[],
      yearopt:[],
      sel_year:null,
      company:{
        reg_year:'',
        name:'',
        add:'',
        add2:'',
        city:'',
        country:'',
        pincode:'',
        companyphone:'',
        email:'',
        gst:'',
        pan:'',
        cin:'',
        tan:'',
        profile:'',
        bankname:'',
        bankaccount:'',
        ifsc:'',
        branch:'',
        micr:'',
        code:'',
        bankholdername:'',
      },
      hasErrors:{
        messageemail:false,
        companyname:false,
        companyadd1:false,
        companyadd2:false,
        companycity:false,
        companycon:false,
        companypin:false,
        compphone:false,
        companymail:false,
        companygst:false,
        companypan:false,
        companycin:false,
        companytan:false,
        bankholdername:false,
        companyprofile:false,
        bankname:false,
        bankifsc:false,
        bankbrnch:false,
        bankmicr:false,
        bankswft:false,
        bankac:false,
        cmptype:false,
        conty:false,
        stateopt1:false,
        ctyopt:false,
        image1:null,
        image2:null,
        image3:null,
        image4:null,
        image5:null
      },
      view:{
        image1:null,
        image2:null,
        image3:null,
        image4:null,
        image5:null,
        image1_href:null,
        image2_href:null,
        image3_href:null,
        image4_href:null,
        image5_href:null,
      }
    }
  },
  computed:{
    super_user: function(){
      return this.$store.getters.get_super_user
    },

    shop_user: function(){
      return this.$store.getters.get_shop_user
    },

    reg_view: function(){
      if(this.$store.getters.get_reg_view === true){
        this.shopuser();
        // this.loading = true
        Promise.all([this.contr(),this.typecmp(),this.editcmp(),this.bankdtl(),this.cmpdetail()]).then(ret_val => {
          // this.loading = false
        });
        return true
      }
      else{
        return false
      }
    },
    reg_rights: function(){
      return this.$store.getters.get_reg_rights
    },
  },

  created(){
    if(localStorage.authUser != null){
      this.access_token = '?access_token='+localStorage.authUser
    }
    var today = new Date();
    var year=today.getFullYear()
    for(var i=1985; i<=year;i++){
      var year_dic = {'year': i.toString()}
      this.yearopt.push(year_dic)
    }
  },

  methods:{
    shopuser(){  
      var _this=this
      this.$http.get('/api/shopusers').then(function(response){

      }).catch(function(error){ 
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null)
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null)
          _this.$router.push('/');
        }
      })
    },
    async editcmp(){
      var _this=this
      var api=''
      var rdata = null
      if('company_id' in this.$route.params){
        api = '/api/companies?filter[where][company_id]=' + this.$route.params['company_id']
      }
      else{
        api = '/api/companies/findOne'
      }
      this.$http.get(api).then(function(response){
        if('company_id' in _this.$route.params){
          rdata = response.data[0]
        }
        else{
          rdata = response.data
        }
        if(rdata !== null){        
        _this.company.name=rdata.company_name
        _this.cmp_type=rdata.company_type
        _this.company.add=rdata.address1
        _this.countryname=rdata.country_code
        _this.statename=rdata.state_code
        _this.cityname=rdata.city
        if(_this.countryname == null){
          _this.countryname = '101';
        }
        if(_this.statename == null){
          _this.statename = '22';
        }
        if(_this.cityname == null){
          _this.cityname = '2707';
        }
        _this.edcontr();
        _this.edstate1();
        _this.edcity1();
        _this.edtypecmp();
        _this.company.pincode=rdata.pincode
        _this.company.companyphone=rdata.com_phone
        _this.company.email=rdata.cmp_email
        _this.company.cin=rdata.cmp_cin
        _this.company.gst=rdata.cmp_gst
        _this.company.pan=rdata.cmp_pan
        _this.company.tan=rdata.cmp_tan
      }
        return Promise.resolve(true)
      }).catch(function(error){
        return Promise.resolve(true)
      })
    },

    async bankdtl(){
      var _this=this
      var api=''
      var rdata=null
      if('company_id' in this.$route.params){
        api = '/api/companybanks?filter[where][company_id]=' + this.$route.params['company_id']
      }
      else{
        api = '/api/companybanks/findOne'
      }
      this.$http.get(api).then(function(response){
         if('company_id' in _this.$route.params){
          rdata = response.data[0]
        }
        else{
          rdata = response.data
        }
      if(rdata !== null){
      _this.company.bankname=rdata.bank_name
      _this.company.bankaccount=rdata.acc_number
      _this.company.ifsc=rdata.ifsc_code
      _this.company.branch=rdata.branch
      _this.company.micr=rdata.micr_code
      _this.company.code=rdata.swift_code
      _this.company.bankholdername=rdata.bank_holder_name
      }
        return Promise.resolve(true)
      }).catch(function(error){
        return Promise.resolve(true)
      })
    },

    async cmpdetail(){
      var _this=this
      var rdata = null
      var api=''
      if('company_id' in this.$route.params){
        api = '/api/companydetails?filter[where][company_id]=' + this.$route.params['company_id']
      }
      else{
        api = '/api/companydetails/findOne'
      }
      
      this.$http.get(api).then(function(response){
        
        if('company_id' in _this.$route.params){
          rdata = response.data[0]
        }
        else{
          rdata = response.data
        }
        
        if(rdata !== null){
          _this.view.image1=rdata.cmp_logo
          _this.view.image2=rdata.cmp_cic_certificate
          _this.view.image3=rdata.cmp_gst_cert
          _this.view.image4=rdata.cmp_pan_cert
          _this.view.image5=rdata.cmp_tan_cert
          _this.view.image1_href=_this.$http.defaults.baseURL+'/api/containers/pics/download/'+rdata.cmp_logo+_this.access_token
          _this.view.image2_href=_this.$http.defaults.baseURL+'/api/containers/pics/download/'+rdata.cmp_cic_certificate+_this.access_token
          _this.view.image3_href=_this.$http.defaults.baseURL+'/api/containers/pics/download/'+rdata.cmp_gst_cert+_this.access_token
          _this.view.image4_href=_this.$http.defaults.baseURL+'/api/containers/pics/download/'+rdata.cmp_pan_cert+_this.access_token
          _this.view.image5_href=_this.$http.defaults.baseURL+'/api/containers/pics/download/'+rdata.cmp_tan_cert+_this.access_token
          _this.company.profile=rdata.cmp_profile
          _this.company.reg_year=rdata.reg_year
          if(_this.company.reg_year !== null && _this.company.reg_year !== undefined && _this.company.reg_year !== ''){
            _this.sel_year = {'year': _this.company.reg_year}
          }
          return Promise.resolve(true)
        }
        else{
          return Promise.resolve(true)
        }      
      }).catch(function(error){
      return Promise.resolve(true)
      })
    },

    async typecmp(){
      var _this=this
      this.$http.get('/api/companytypes').then(function(response){
        _this.comptype1=  response.data;
        return Promise.resolve(true)
      }).catch(function(error){
        return Promise.resolve(true)
      })
    },

    async contr(){
      var _this=this
      this.$http.get('/api/countries').then(function(response){
        _this.conopt=response.data;
        return Promise.resolve(true);
      }).catch(function(error){
        return Promise.resolve(true);
      })
    },

    state1(conopt){
      this.stateopt = [];
      this.cityopt=[];
      this.state = null
      this.city = null
      var _this=this
      var id=conopt.id
      this.$http.get('/api/states?filter[where][country_id]='+id).then(function(response){
        _this.stateopt=  response.data;
      }).catch(function(error){

      })
    },

    city1(stateopt){
      this.cityopt=[];
      this.city=null
      var _this=this
      var id=stateopt.id
      this.$http.get('/api/cities?filter[where][state_id]='+id).then(function(response){
        _this.cityopt=  response.data;
      }).catch(function(error){

      })
    },

    edcontr(){
      var _this=this
      if(this.countryname!=null){
        this.$http.get('/api/countries/'+_this.countryname).then(function(response){
          _this.con = response.data
        }).catch(function(error){

        })
        this.$http.get('/api/states?&filter[where][country_id]='+_this.countryname).then(function(response){
          _this.stateopt = response.data;
        }).catch(function(error){

        })
      }
    },

    edstate1(){
      var _this=this
      if(this.statename!=null){
        this.$http.get('/api/states/'+_this.statename).then(function(response){
          _this.stateo1 = response.data;
        }).catch(function(error){

        })
        this.$http.get('/api/cities?filter[where][state_id]='+_this.statename).then(function(response){
          _this.cityopt = response.data
        }).catch(function(error){

        })
      }
    },
   
    edcity1(){
      var _this=this
      if(this.cityname!=null){
        this.$http.get('/api/cities/'+this.cityname).then(function(response){
          _this.city = response.data
        }).catch(function(error){

        })
      }
    },
    
    edtypecmp(){
      var _this=this
      var id = this.cmp_type
      if(this.cmp_type!=null){
        this.$http.get('/api/companytypes/'+id).then(function(response){
          _this.selectedCategory = response.data
         
        }).catch(function(error){

        })
      }
    },

    image1(callback){
      var _this = this
      const image1 = document.querySelector('#image1');
      if(this.view.image1!=null){
        if(image1.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.view.image1)
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return this.view.image1
        }
      }else{
        if(image1.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return null;
        }        
      }
    },

    image2(callback){
      var _this = this
      const image2 = document.querySelector('#image2');
      if(this.view.image2!=null){
        if(image2.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.view.image2)
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return this.view.image2
        }
      }else{
        if(image2.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return null;
        }        
      }
    },

    image3(callback){
      var _this = this
      const image3 = document.querySelector('#image3');
      if(this.view.image3!=null){
        if(image3.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.view.image3)
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return this.view.image3
        }
      }else{
        if(image3.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return null;
        }        
      }
    },

    image4(callback){
      var _this = this
      const image4 = document.querySelector('#image4');
      if(this.view.image4!=null){
        if(image4.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.view.image4)
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return this.view.image4
        }
      }else{
        if(image4.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return null;
        }        
      }
    },

    image5(callback){
      var _this = this
      const image5 = document.querySelector('#image5');
      if(this.view.image5!=null){
        if(image5.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image5.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.view.image5)
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return this.view.image5
        }
      }else{
        if(image5.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image5.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return null;
        }        
      }
    },
    resetError()
    {

      this.messagesucc1=false;
      this.hasErrors.cmptype=false;
      this.hasErrors.companyname =false;
      this.hasErrors.companyadd1 =false;
      this.hasErrors.companymail =false;
      this.hasErrors.companycity =false;
      this.hasErrors.companycon =false;
      this.hasErrors.companypin =false;
      this.hasErrors.compphone =false;
      this.hasErrors.companymail =false;
      this.hasErrors.companygst =false;
      this.hasErrors.companypan =false;
      this.hasErrors.companycin =false;
      this.hasErrors.companytan =false;
      this.hasErrors.companyprofile =false;
      this.hasErrors.conty=false;
      this.hasErrors.stateopt1=false;
      this.hasErrors.ctyopt=false;
      this.hasErrors.image1=null;
      this.hasErrors.image2=null;
      this.hasErrors.image3=null;
      this.hasErrors.image4=null;
      this.hasErrors.image5=null;

    },
    onComplete(chk,value){
      var nregex=/^[a-zA-Z\s]{3,100}$/
      var regex=/^[a-zA-Z0-9\s]{3,100}$/
      var regexifsc=/^[A-Z|a-z]{4}[0][\d]{6}$/
      var regexswift=/ ^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/
      var panregex=/^[A-Za-z]{5}\d{4}[A-Za-z]{1}$/
      var mobregex=/^[0-9]{10,15}$/
      var pirex=/^[0-9]{6}$/
      var accregex=/^[0-9]{16}$/
      var brex=/^[a-zA-Z0-9\s]{3,100}[!@#$%^.,%&<>'":;/_|]{0,3}$/
      // var eregex= /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)[a-z0-9]{2,3}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/
      var eregex= /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/

          if(value=='cmptype' || chk == 'check')
          {  
            if(this.selectedCategory)
            {
              if(!this.selectedCategory.companycode)
              {
                this.hasErrors.cmptype='Required'
                this.submit_true=1;
              }else{  this.hasErrors.cmptype=''}
            }
            else if(!this.selectedCategory)
               {
                this.hasErrors.cmptype='Required'
                this.submit_true=1;
              }else{  this.hasErrors.cmptype=''}
          }

 
        if(value == 'con' || chk == 'check' )
          {
           if(this.con)
                {
                  if(!this.con.country_name){ 
                    this.hasErrors.conty='Required';
                    this.hasErrors.stateopt1='Required';
                    this.hasErrors.ctyopt='Required';
                    this.stateo1=null
                    this.city=null
                  
                    this.submit_true=1;
                  }else{
                    this.hasErrors.conty='';
                    this.hasErrors.stateopt1='';
                    this.hasErrors.ctyopt='';
                  }
                }else if(!this.con)
                {
                   this.hasErrors.conty='Required';
                    this.hasErrors.stateopt1='Required';
                    this.hasErrors.ctyopt='Required';
                    this.stateo1=null
                    this.city=null
                    this.submit_true=1;
                }else{
                    this.hasErrors.conty='';
                    this.hasErrors.stateopt1='';
                    this.hasErrors.ctyopt='';
                }
          }


          if(value == 'gst' || chk == 'check')
          {  
          if(this.company.gst )
              {  
                if(this.company.gst.length > 100)
                    { 
                      this.hasErrors.companygst = 'Enter maximum 100 characters'
                      this.submit_true=1;
                    }else{this.hasErrors.companygst = ''}
              }
          }

           

          if(value == 'state' || chk == 'check')
          {  if(this.stateo1)
                {
                  if(!this.stateo1.state_name){ 
                      this.hasErrors.stateopt1='Required';
                      this.hasErrors.ctyopt='Required';
                      this.city=null
                      this.submit_true=1;
                    }else{
                      this.hasErrors.stateopt1='';
                      this.hasErrors.ctyopt='';
                      }
                }else if(!this.stateo1)
                {
                   this.hasErrors.stateopt1='Required';
                   this.hasErrors.ctyopt='Required';
                   this.city=null
                   this.submit_true=1;
                }
                else{
                this.hasErrors.stateopt1='';
                this.hasErrors.ctyopt='';
               }

          }
          if(value == 'city' || chk == 'check')
          {  
             if(this.city)
             { 
               if(!this.city.city_name)
                  {
                    this.hasErrors.ctyopt='Required';
                    this.submit_true=1;
                  }else{this.hasErrors.ctyopt='';}
             }else if(!this.city)
              {
                 this.hasErrors.ctyopt='Required';
                 this.submit_true=1;
              }else{this.hasErrors.ctyopt='';}

          }
               
            if(value == 'cmpname' || chk == 'check')
            { 
                if(!this.company.name)
                {
                    this.hasErrors.companyname ='Required';
                    this.submit_true=1;
                }
                else if(this.company.name.length > 100)
                  {
                    this.hasErrors.companyname ='Enter maximum 100 characters';
                    this.submit_true=1;
                  }
                else if(this.company.name.length < 2)
                {
                    this.hasErrors.companyname  ='Enter minimum 2 characters';
                    this.submit_true=1;
                } else{  this.hasErrors.companyname  ='';}
              

}

          if(value == 'pncd' || chk == 'check')
          {  
             
                if(pirex.test(this.company.pincode)==false){
                 
                  if(!this.company.pincode){ 
                    this.hasErrors.companypin ='Required'
                    this.submit_true=1;
               }
                else{                        
                    this.hasErrors.companypin ='Enter valid pincode'
                    this.submit_true=1;}
               }
              else{  this.hasErrors.companypin =''; }
           
          }

          if(value == 'address'  || chk == 'check')
          {
           if(this.company.add)
            {
             if(this.company.add.length > 100)
                {
                   this.hasErrors.companyadd1 ='Enter maximum 100 characters';
                   this.submit_true=1;
                }
               else if(this.company.add.length < 2 && this.company.add.length > 0)
                 { 
                  this.hasErrors.companyadd1 ='Enter minimum 2 characters'; 
                  this.submit_true=1;
                 } 
              else{  this.hasErrors.companyadd1  ='';}
            }else{  this.hasErrors.companyadd1  ='';}
               
          }
                
            if(value=='companyphone'  || chk == 'check')
            { 
               if(!this.company.companyphone) 
                  {
                      this.hasErrors.compphone ='Required';
                      this.submit_true=1;
                  }
                else if(mobregex.test(this.company.companyphone)==false)
                 {    
                       this.hasErrors.compphone ='Invalid Phone number';
                       this.submit_true=1;
                  } else{  this.hasErrors.compphone  ='';}
                

            }
           if(value == 'email' || chk == 'check')
           {
                if(eregex.test(this.company.email)== false)
                {
                  if(!this.company.email)
                    {
                       this.hasErrors.companymail ='Required';
                    }
                  else{
                       this.hasErrors.companymail ='Enter valid email';
                      }
                       this.submit_true=1;
                } else if(this.company.email.length > 70)
                      {
                        this.hasErrors.companymail ='Maximum 70 characters';
                      }

                else{  this.hasErrors.companymail  ='';}
            }

           if(value == 'pan' || chk == 'check')
           {
                if(panregex.test(this.company.pan)==false){
                if(!this.company.pan)
                  {
                     this.hasErrors.companypan ='Required';
                  }
                else
                 {
                  this.hasErrors.companypan ='Enter valid pan number';
                 }
                  this.submit_true=1;
                }
               
                else{  this.hasErrors.companypan  ='';}
          }

          if(value=='logo' || chk == 'check')
          {
            if('files' in image1){
           if(image1.files[0] !== undefined){
                  if(image1.files[0].size>this.maximumSize)
                  {
                    this.hasErrors.image1="Image Size Cannot Be Greater Than 500kb"
                    this.submit_true=1;
                  }else{  this.hasErrors.image1  ='';}
                  if(this.allowableLogoTypes.indexOf(image1.files[0].type.toLowerCase())=== -1)
                  {
                    this.hasErrors.image1="Invalid File Type"
                    this.submit_true=1;
                  }else{  this.hasErrors.image1  ='';}
                }
              }
          }
                
          if(value == 'cin' || chk == 'check')
          {
            if(this.company.cin)
            {
              if(this.company.cin.length > 100)
                  {
                    this.hasErrors.companycin = 'Enter maximum 100 characters'
                        this.submit_true=1;
                  }
                  else{  this.hasErrors.companycin  ='';}
            }
          }
            if(value == 'cincert' || chk == 'check')
            {  
              if('files' in image2){
                if(image2.files[0]!=undefined){
                  if(image2.files[0].size>this.maximumSize){
                    this.hasErrors.image2="Image Size Cannot Be Greater Than 500kb"
                  this.submit_true=1;
                  }else{  this.hasErrors.image2  ='';}
                  if(this.allowableTypes.indexOf(image2.files[0].type.toLowerCase())=== -1){
                    this.hasErrors.image2="Invalid File Type"
                  this.submit_true=1;
                  }else{  this.hasErrors.image2  ='';}
                }
              }
            }

            if(value== 'gstcert' || chk == 'check')
            {
              if('files' in image3){
                if(image3.files[0]!=undefined){
                  if(image3.files[0].size>this.maximumSize){
                    this.hasErrors.image3="Image Size Cannot Be Greater Than 500kb"
                  this.submit_true=1;
                  }else{  this.hasErrors.image3  ='';}
                  if(this.allowableTypes.indexOf(image3.files[0].type.toLowerCase())=== -1){
                    this.hasErrors.image3="Invalid File Type"
                  this.submit_true=1;
                  }else{  this.hasErrors.image3  ='';}
                }
              }
            }

          if(value == 'pancert' || chk == 'check')
          {
            if('files' in image4){
                if(image4.files[0]!=undefined){
                  if(image4.files[0].size>this.maximumSize){
                    this.hasErrors.image4="Image Size Cannot Be Greater Than 500kb"
                  this.submit_true=1;
                  }else{  this.hasErrors.image4  ='';}
                  if(this.allowableTypes.indexOf(image4.files[0].type.toLowerCase())=== -1){
                    this.hasErrors.image4="Invalid File Type"
                  this.submit_true=1;
                  }else{  this.hasErrors.image4  ='';}
                }
              }
          }
          if(value == 'tan' || chk == 'check')
          {
            if(this.company.tan){
                        if(this.company.tan.length>12)
                        {
                          this.hasErrors.companytan='Enter valid TAN number'
                              this.submit_true=1;
                        }else{  this.hasErrors.companytan  ='';}
                      }

          }
          if(value == 'tancert' || chk == 'check')
          { 
            if('files' in image5){
                if(image5.files[0]!=undefined){
                  if(image5.files[0].size>this.maximumSize){
                    this.hasErrors.image5="Image Size Cannot Be Greater Than 500kb"
                  this.submit_true=1;
                  }else{  this.hasErrors.image5  ='';}
                  if(this.allowableTypes.indexOf(image5.files[0].type.toLowerCase())=== -1){
                    this.hasErrors.image5="Invalid File Type"
                  this.submit_true=1;
                  }else{  this.hasErrors.image5  ='';}
                }
              }
          }
          if(value =='profile' || chk == 'check')
          {
             if(this.company.profile)
                {
                  if(this.company.profile.length > 1000){
                      this.hasErrors.companyprofile ='Profile cannot be greater than 1000 Character';
                      this.submit_true=1;
                    }else{  this.hasErrors.companyprofile  ='';}
                }else{  this.hasErrors.companyprofile  ='';}
          }
          if(value == 'bankname' || chk == 'check')
          {
            if(this.company.bankname)
                {
                  if(this.company.bankname.length > 20 )
                      {
                        this.hasErrors.banknm = 'Enter maximum 20 characters'
                        this.submit_true=1;
                      }else{  this.hasErrors.banknm  ='';}
                  }

          }

          if(value  == 'bankhldname' || chk == 'check')
          {
              if(this.company.bankholdername) 
                 {
                  if(this.company.bankholdername.length>70)
                   {
                     this.hasErrors.bankholdername ='Enter maximum 70 characters'
                     this.submit_true=1;
                   }else{  this.hasErrors.bankholdername  ='';}
                 }

          }

          if(value=='bankacc' || chk == 'check')
          { 
            if(this.company.bankaccount)
            {
              if(this.company.bankaccount.length > 30)
                        {
                          this.hasErrors.bankac ='Enter maximum 30 characters'
                              this.submit_true=1;
                        }else{  this.hasErrors.bankac  ='';}
            }
          }
          if(value == 'ifsc' || chk == 'check')
          {
            if(this.company.ifsc)
            {  
              if(this.company.ifsc.length > 20)
              {
                this.hasErrors.bankifsc ='Enter maximum 20 characters'
                    this.submit_true=1;
              }else{  this.hasErrors.bankifsc  ='';}
            }

          }

          if(value == 'micr' || chk == 'check')
          {
            if(this.company.micr)
            {
              if(this.company.micr.length > 20)
                {
                  this.hasErrors.bankmicr ='Enter maximum 20 characters'
                      this.submit_true=1;
                }else{  this.hasErrors.bankmicr  ='';}
            }

          }
          if(value == 'branch' || chk == 'check')
          {
            if(this.company.branch)
            {
              if(this.company.branch.length > 20)
                  {
                    this.hasErrors.bankbrnch ='Enter maximum 20 characters'
                    this.submit_true=1;
                  }else{  this.hasErrors.bankbrnch  ='';}
              }

          }

        if(value == 'swiftcode' || chk == 'check')
        {
          if(this.company.code)
          {
            if(this.company.code.length> 20)
                    {
                      this.hasErrors.bankswft ='Enter maximum 20 characters'
                            this.submit_true=1;
                    }else{  this.hasErrors.bankswft  ='';}
          }

        } 
},

finalSave(){    
      this.messagesucc1=false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.submit_true=0
      this.onComplete('check','false')
      var _this=this
      if(this.submit_true==0){
         this.loading = true
          var data = {};
          Promise.all([this.image1(),this.image2(),this.image3(),this.image4(),this.image5()]).then(user=>{
            if(this.sel_year !== null){
              if('year' in this.sel_year){
                this.company.reg_year = this.sel_year['year']
              }
              else{
                this.company.reg_year = null
              }
            }
            
            data.gst=this.company.gst
            data.cic=this.company.cic
            data.pan=this.company.pan
            data.profile=this.company.profile
            data.banknm=this.company.banknm
            data.account=this.company.ac
            data.ifsc=this.company.ifsc
            data.branch=this.company.branch
            data.micr=this.company.micr
            data.code=this.company.code
            data.company_name=this.company.name
            data.company_type=this.selectedCategory.id
            data.address1=this.company.add
            data.address2=this.company.add2
            data.city=this.city.id
            data.country_code=this.con.id
            data.state_code=this.stateo1.id
            data.pincode=this.company.pincode
            data.com_phone=this.company.companyphone
            data.cmp_email=this.company.email
            data.cmp_gst=this.company.gst
            data.cmp_pan=this.company.pan
            data.cmp_cin=this.company.cin
            data.cmp_tan=this.company.tan
            data.banknm=this.company.bankname
            data.account=this.company.bankaccount
            if(this.company.reg_year !== null && this.company.reg_year !== undefined){
              data.reg_year=this.company.reg_year
            }
            else{
              data.reg_year=''
            }
            data.bank_holder_name=this.company.bankholdername
            data.cmp_logo=user[0]
            data.cmp_cic_certificate=user[1]
            data.cmp_gst_cert=user[2]
            data.cmp_pan_cert=user[3]
            data.cmp_tan_cert=user[4]
            var api = ''
            if('company_id' in this.$route.params){
              api = '/api/companies/upsertWithWhere?filter[where][company_id]=' + this.$route.params['company_id']
            }
            else{
              api = '/api/companies/upsertWithWhere'
            }
            this.$http.post(api, data).then(function (response) {
              _this.loading = false;
              _this.messagesucc1=true
              _this.messagesucc=" Successfully Updated";
              setTimeout(function(){ _this.messagesucc='';}, 2000);
              _this.contr();
              _this.typecmp();
              _this.editcmp();
              _this.bankdtl();
              _this.cmpdetail();
            })
            .catch(function (error) {
              _this.messagesucc1=true
              _this.messagesucc="Something went Wrong";
              _this.loading = false;
              setTimeout(function(){ _this.messagesucc='';}, 2000);
            });

          });
      }
    },
    
    setLoading: function(value) {
      this.loadingWizard = value
    },
  }
}
</script>

<style type="text/css">
  .star{
    font-weight: 500;
    color: #ae1212; 
  }

  .fa-angle-double-right{
    margin-top: 5px !important;
  }

  .filesize{
    padding-bottom: 4px;
    padding-top: 4px;
  }
</style>


// WEBPACK FOOTER //
// src/views/Registration.vue